import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'

export const Container = styled.div`
  background-color: ${Colors.Neutral5};
  border-radius: ${Spacing['2XS']};
  gap: ${Spacing.S};
  display: flex;
  flex-direction: column;
  padding: ${Spacing.S};
`

export const Item = styled.div`
  display: flex;
  gap: ${Spacing.XS};
  align-items: center;
`

export const Number = styled.div`
  flex-shrink: 0;

  ${Typography.Caption};

  background-color: ${Colors.Blue50};
  color: ${Colors.White};

  display: flex;
  width: 22px;
  height: 22px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 50%;
`

export const Text = styled.div`
  ${Typography.Body};
  color: ${Colors.Neutral90};
`
